// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QHEjV","left":"styles_left__1gXrR","desktopActions":"styles_desktopActions__3PJX_","title":"styles_title__3rnKM"};